import { SB } from '@play-co/replicant';

const specialCompensationBucket = SB.tuple([
  '2501_5000_FreeGems',
  '5001_10000_FreeGems',
  '10_001_20000_FreeGems',
  '20001_FreeGems',
  '10k_PaidGems',
  'none',
]).default('none');

export const m2migrationSchema = {
  /**
   * @deprecated
   *
   * TODO: Remove this after week after merge
   */
  m2Migration: SB.object({
    // Is m2migration was executed for this user
    finished: SB.boolean().default(false),
    // Migration bucket by paid gems spend
    bucket: SB.tuple(['moreThan10k', 'lessThan10K', 'default']).default(
      'default',
    ),

    /**
     * Special compensation for match2 migration
     */

    // Is Match-2 Migration Special Compensation finished?
    specialCompensation: SB.boolean().default(false),

    // Compensation bucket for admin messages
    specialCompensationBucket,

    // Should show migration popup.
    shouldShowMigrationPopup: SB.boolean().default(false),
  }).optional(),
};

export type SpecialCompensationBucket = SB.ExtractType<
  typeof specialCompensationBucket
>;
